import React from "react";

const Barley = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Barley</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
       <table className=" table table-striped table-bordered">
       <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr></tr>
            <tr>
              <td colspan="6">
                <strong>BH-75</strong>
              </td>
            </tr>
            <tr>
              <td>30 to 35 kgs per acre</td>
              <td>15th October to 15th November</td>
              <td>2-3</td>
              <td>120-125 days</td>
              <td>
                Suitable for irrigated areas. Dwarf variety. Medium spreading
                loose earheads. Susptible to yellow &amp; Molya disease.
              </td>
              <td>14-16 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PL-426 [Released in 01.01.1996]</strong>
              </td>
            </tr>
            <tr>
              <td>30 to 35 kgs per acre</td>
              <td>15th October to 15th November</td>
              <td>2-3</td>
              <td>120-125 days</td>
              <td>
                Suitable for irrigated and timely sown. Better variety for Malt.
                Lodging, yellow rust and smut resistant.
              </td>
              <td>18-19 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>BH-393 [Released in 04.09.2002]</strong>
              </td>
            </tr>
            <tr>
              <td>30 to 35 kgs per acre</td>
              <td>For early sowing</td>
              <td>2-3</td>
              <td>120 days</td>
              <td>
                Resistant to yellow / brown &amp; Molya disease. Plant height
                80cm. Suitable for Malt &amp; Brewery industry.
              </td>
              <td>19 quintals per acre</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Barley;
